import { TypographyStyle } from "@mui/material/styles";
import fonts from "./fonts";
import breakpoints from "./breakpoints";

const typographyVariants: Record<string, TypographyStyle> = {
  h1: {
    fontFamily: fonts.regular,
    fontWeight: "normal",
    letterSpacing: "normal",
    fontSize: "30px",
    lineHeight: "40px",
    [breakpoints.up("md")]: {
      fontSize: "50px",
      lineHeight: "66px",
    },
  },
  body1: {
    fontFamily: fonts.regular,
    fontSize: "14px",
    letterSpacing: "normal",
    lineHeight: "20px",
  },
  body2: {
    fontFamily: fonts.regular,
    fontSize: "18px",
    letterSpacing: "normal",
    lineHeight: "28px",
  },
  subtitle1: {
    fontFamily: fonts.bold,
    fontSize: "14px",
    letterSpacing: "normal",
    lineHeight: "20px",
    [breakpoints.up("md")]: {
      fontSize: "18px",
      lineHeight: "25px",
    },
  },
  overline: {
    fontFamily: fonts.bold,
    fontSize: "10px",
    letterSpacing: "1.5px",
    lineHeight: "inherit",
    textTransform: "uppercase",
    [breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  button: {
    fontFamily: fonts.bold,
    fontSize: "12px",
    letterSpacing: "normal",
    textTransform: "uppercase",
  },
};

const typography = {
  fontFamily: fonts.regular,
  ...typographyVariants,
};

export default typography;
